import script from "./InventoryDefact.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryDefact.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__